<template>
    <div class="body">
        <div class="columns is-desktop is-vcentered is-variable is-8">
            <div class="column is-narrow">
                <img class="logo" src="img/smplogo.svg">
            </div>
            <div class="column">
                <h1 class="title has-text-primary">About SMP&CO Partners</h1>
                <p>SMP&CO Partners, Inc. is a strategy innovations, management consultancy, and technology importer & developer based in Manila, Philippines.</p>
                <p>We believe in building sustainable and inclusive free markets by investing in new technologies and processes for the use of our clients in the Philippines.</p>
                <p>Our field of expertise include deal-flow management, innovations consulting, technology solutions development, technology importing, global trade and finance, bespoke medium-large scale M&A, business brokering, and compradore servicing for foreign firms entering the Philippine Market.</p>
                <p>Learn more about our work and publications at smpcopartners.com</p>
                <b-button tag="a" href="https://smpcopartners.com" type="is-primary" target="_blank">Visit our Website</b-button>
            </div>
        </div>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    export default {
        name: "AboutSmp",
        components: {BButton}
    }
</script>

<style scoped>
    .logo {
        width: 320px;
    }

    .body {
        padding-left: 10%;
        padding-right: 10%;
        padding-top: 72px;
        padding-bottom: 72px;
    }
</style>